<template>
  <div id="LaySongList">
    <div class="left_Title">
      <p>
        <i class="iconfont iconjieguo"></i>
        <span class="aqt_lang_mn titlefont">{{ $t('m.seareturn') + '&nbsp;' + '(' + total + ')'  |U2M }}</span>
      </p>
      <p></p>
    </div>
    <div v-if="!isNo" class="list_Content aqt_no_su" ref="Content_Width">
      <div class="listBox_item" style="min-width: 50px" v-for="(item,index) in list" :key='index'
           @click.stop="getSound(item)">
        <div class="title aqt_lang_mn titlefont">
          {{ item.titlelang ? (item.titlelang.mn ? item.titlelang.mn : item.titlelang.zh) : '' | U2M }}
        </div>
        <div v-if="(item.lyricistlang&&(item.lyricistlang.mn||item.lyricistlang.zh))"
             class="atour aqt_lang_mn titlefont">
          <!--                作词人-->
          <span>{{ 'ᠦᠭᠡ : '|U2M }}</span> {{
            item.lyricistlang ? (item.lyricistlang.mn ? item.lyricistlang.mn : item.lyricistlang.zh) : '' | U2M
          }}
        </div>
        <div v-if="(item.composerlang&&(item.composerlang.mn||item.composerlang.zh))"
             class="atour aqt_lang_mn titlefont">
          <!--                作曲人-->
          <span>{{ 'ᠠᠶ᠎ᠠ : '|U2M }}</span> {{
            item.composerlang ? (item.composerlang.mn ? item.composerlang.mn : item.composerlang.zh) : '' | U2M
          }}
        </div>
<!--        <div v-if="(item.translatorlang&&(item.translatorlang.mn||item.translatorlang.zh))"-->
<!--             class="atour aqt_lang_mn titlefont">-->
<!--          &lt;!&ndash;                翻译人&ndash;&gt;-->
<!--          <span>{{ 'ᠣᠷᠴᠢᠭᠤᠯᠤᠭᠴᠢ : '|U2M }}</span> {{-->
<!--            item.translatorlang ? (item.translatorlang.mn ? item.translatorlang.mn : item.translatorlang.zh) : '' | U2M-->
<!--          }}-->
<!--        </div>-->
        <div v-if="item.wordlang&&(item.wordlang.mn||item.wordlang.zh)"
             class="content aqt_lang_mn contentfont">
          <div class="p"
               v-html="U2M(item.wordlang ? (item.wordlang.mn ? item.wordlang.mn.trim(): (item.wordlang.zh?item.wordlang.zh:'')) : '')">
          </div>
        </div>
      </div>
    </div>


    <div class="page">
      <PageMn v-if="!isNo" :total="total" :current="current_page"
              :pageSize="per_page" @getPager="getPager">
        </PageMn>
      <!-- <Page v-if="!isNo" :total="total" :current="current_page" 
            :page-size="per_page"
            @on-change="getPager"/> -->
    </div>
    <div v-if="isNo&&!list.length" class="nomassage">
      <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
    </div>
    <!--    加载动画-->
    <AqtSpin v-if="isSpin"></AqtSpin>
  </div>
</template>
<script>
export default {
  props: {
    songType: [String]
  },
  computed: {
    // 背景音乐显示
    showBgmusic() {
      return this.$store.getters.showBgmusic
    },
  },
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      booksSearch: {
        per_page: 10,
        page: 1,
        title: '',
        lang: 'mn', //语言 mn zh
        classify_id: 0,//分类id  原创241
        didai_id: 0,//地带分类id
        leixing_id: 0,//歌的分类id
        crowd_id: 0,//人群分类
      },
      isSpin: false,
    }
  },
  methods: {
    /******************************************
     *
     *分页器
     *
     *****************************************/
    getPager(page) {
      let that = this
      that.list = []
      that.booksSearch.page = page
      that.getList()
    },
    getList() {
      let that = this
      // that.isNo = true
      that.isSpin = true

      that.$httpsencrypt.post(`api/web/v3/songbase/list`, that.booksSearch)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1


              that.list = val.data
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              thst.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
      if (!that.showBgmusic) {
        let query = {
          lang:'mn',
          classify_id: that.booksSearch.classify_id,//分类id  原创241
          didai_id: that.booksSearch.didai_id,//地带分类id
          leixing_id: that.booksSearch.leixing_id,//歌的分类id
          crowd_id: that.booksSearch.crowd_id,//人群分类
        }
        that.$store.dispatch('getAllaodio', query).then(() => {
        })
      }

    },

    //进入详情
    getSound(val) {
      let that = this
      that.$router.push({
        path: '/SongDetails',
        query: {
          ItemInfor: that.$crypto.set(val.song_base_id),
          lib_type:sessionStorage.getItem('gcm')
        }
      })
      let kk ={
        classify_id: that.booksSearch.classify_id,//分类id  原创241
        didai_id: that.booksSearch.didai_id,//地带分类id
        leixing_id: that.booksSearch.leixing_id,//歌的分类id
        crowd_id: that.booksSearch.crowd_id,//人群分类
      }
      that.$store.commit('SET_SongSearch', kk)
    }
  },

  created() {
    let info={
      type: 18,
      path: this.$route.path,
      mark: '歌列表',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
    let that = this
    let kk = that.$refs.Content_Width.clientWidth / 80
    that.booksSearch.per_page = Math.floor(kk)
    if (that.songType == 'child_song') {
      that.booksSearch.crowd_id = 100
    }
    that.getList()
  },

}
</script>
<style lang="less" scoped>
#LaySongList {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  .contentfonts1 {
    font-size: 1.6rem;
  }

  .nomassage {
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
    color: #888888;
  }

  .left_Title {
    width: 54px;
    height: 100%;
    background: #ffffff;
    margin-right: 2px;
    padding-top: 27px;
    display: flex;
    justify-content: flex-end;


    p:nth-child(1) {
      width: 24px;
      color: var(--themeColor);
      font-size: 20px;
      line-height: 24px;

      i {
        font-size: 24px;

      }
    }

    p:nth-child(2) {
      width: 8px;
      height: 162px;
      background: var(--themeColor);
      margin-left: 10px;
    }
  }

  .list_Content {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    overflow-x: auto !important;

    .listBox_item {
      max-height: 100%;
      background-color: #ffffff;
      border-radius: 3px;
      display: flex;
      padding: 10px 10px;
      margin-right: 5px;
      cursor: pointer;

      .title {
        width: 30px;
        max-height: 100%;
        font-size: 20px;
        padding-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #888888;
      }

      .atour {
        width: 25px;
        max-height: 100%;
        font-size: 18px;
        color: #888888;
        padding-top: 30px;
        line-height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .content {
        width: 50px;
        max-height: 100%;
        font-size: 20px;
        padding: 10px 0px;
        color: #888888;

        .p {
          padding-top: 10px;
          height: calc(96vh - 100px);
          width: 50px;
          line-height: 25px;
          overflow: hidden;
          white-space: pre-line;

        }

      }

      .submin {
        width: 20px;
        max-height: 100%;
        font-size: 26px;
        padding: 10px 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .sub_item1 {
          width: 20px;

          .sub_item {
            border-radius: 50px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            border: 1px solid var(--themeColor);

            i {
              font-size: 20px;
              margin-bottom: 5px;
            }
          }
        }


        .sub_item2 {
          // padding: 20px;
          color: #888888;
          font-size: 18px;

          span {
            margin-bottom: 5px;
          }
        }
      }
    }

    .listBox_item:hover {
      .title {
        color: var(--themeColor);
      }

      .atour {
        color: var(--themeColor);
      }

      .content {
        color: var(--themeColor);
      }
    }
  }

  .list_Content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  .list_Content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .list_Content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .page {
    width: 50px;
    height: 100%;
  }
}
</style>

